import { render } from "./AddCastrStream2.vue?vue&type=template&id=ccb0ad56&scoped=true"
import script from "./AddCastrStream2.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCastrStream2.vue?vue&type=script&setup=true&lang=js"

import "./AddCastrStream2.vue?vue&type=style&index=0&id=ccb0ad56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb0ad56"],['__file',"src/components/ui/AddCastrStream2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ccb0ad56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ccb0ad56', __exports__)) {
    api.reload('ccb0ad56', __exports__)
  }
  
  module.hot.accept("./AddCastrStream2.vue?vue&type=template&id=ccb0ad56&scoped=true", () => {
    api.rerender('ccb0ad56', render)
  })

}


export default __exports__